import React from 'react';
import { css } from '@emotion/react';
import t from 'react-translate';
import NvIcon from 'shared/components/nv-icon';
import { gray5, gray6, gray7 } from 'styles/global_defaults/colors';
import { headerRegularLineHeight } from 'styles/global_defaults/fonts';
import { largeSpacing, doubleSpacing, halfSpacing } from 'styles/global_defaults/scaffolding';
import NewProgramButton from 'athena/components/new-program-button';

type Props = {
  onCreate: (createdProgramId: number) => void;
  dataQa?: string;
};

const styles = css`
  padding: ${largeSpacing}px 0;
  border: 1px solid ${gray5};
  margin: ${doubleSpacing}px;
  gap: ${halfSpacing}px;
  background-color: ${gray7};

  .icon-circle {
    width: 50px;
    height: 50px;
    background-color: ${gray6};
  }

  .title {
    line-height: ${headerRegularLineHeight}px;
  }

  .subtitle {
    max-width: 400px;
  }
`;

const MentoringProgramsEmptyState = ({ onCreate, dataQa }: Props) => (
  <div css={styles} className='d-flex flex-column align-items-center' data-qa={dataQa}>
    <div className='d-flex align-items-center justify-content-center rounded-circle icon-circle'>
      <NvIcon icon='mentor-plus' size='medium' className='text-white' />
    </div>
    <div className='text-medium text-center subtitle'>
      <div className='text-large-regular font-weight-bold black title'>{t.MENTORING_PROGRAMS.NO_PROGRAMS_YET()}</div>
      <div className='gray-2'>
        {t.MENTORING_PROGRAMS.NO_PROGRAMS_YET_SUBTITLE()}
      </div>
    </div>
    <NewProgramButton onCreate={onCreate} label={t.MENTORING_PROGRAMS.CREATE_FIRST_PROGRAM()} />
  </div>
);

export default MentoringProgramsEmptyState;
